// Só separadores, nunca "tudo que não é dígito": `12345678901x` não pode virar um CPF plausível.
const DOCUMENT_SEPARATORS = /[.\-/\s]/g;
const PHONE_SEPARATORS = /[().\-\s]/g;

export function stripDocumentSeparators(value: string): string {
  return value.replace(DOCUMENT_SEPARATORS, '');
}

export function stripPhoneSeparators(value: string): string {
  return value.replace(PHONE_SEPARATORS, '');
}

// `ASCII − 48`, como a IN RFB nº 2.229/2024 define: dígitos valem eles mesmos e letras continuam a
// sequência (A = 17). É isso que deixa uma implementação só servir CNPJ numérico e alfanumérico.
export function charValueAt(value: string, index: number): number {
  return value.charCodeAt(index) - 48;
}
